import { useContext } from 'react';
import { LoginStateContext } from '../LoginStateProvider';

export const useLoginState = () => useContext(LoginStateContext);
